(function() {
  var API_BASE = 'https://ikrush-feeds-production.up.railway.app';

  function fetchRecommendations(endpoint, params) {
    var url = new URL(endpoint, API_BASE);
    Object.entries(params).forEach(function(entry) { url.searchParams.set(entry[0], entry[1]); });
    return fetch(url.toString())
      .then(function(resp) { return resp.ok ? resp.json() : null; })
      .catch(function() { return null; });
  }

  function renderProductCard(product) {
    var hasCompare = product.compare_at_price && parseFloat(product.compare_at_price) > parseFloat(product.price);
    var priceClass = hasCompare ? 'text-on-sale' : 'text-subdued';
    var compareHtml = hasCompare
      ? '<compare-at-price class="text-subdued line-through">' +
          formatPrice(product.compare_at_price) +
        '</compare-at-price>'
      : '';

    var imgSrc = product.image.includes('?') ? product.image + '&width=600' : product.image + '?width=600';
    var title = (product.title || '').replace(/"/g, '&quot;').replace(/</g, '&lt;');

    return '<div class="product-card" style="scroll-snap-align:start">' +
      '<div class="product-card__figure">' +
        '<a href="/products/' + product.handle + '" class="product-card__media" draggable="false">' +
          '<img src="' + imgSrc + '" alt="' + title + '" loading="lazy" class="product-card__image product-card__image--primary object-cover aspect-portrait">' +
        '</a>' +
      '</div>' +
      '<div class="product-card__info">' +
        '<div class="v-stack justify-items-center gap-2">' +
          '<div class="v-stack justify-items-center gap-1">' +
            '<a href="/products/' + product.handle + '" class="product-title">' + product.title + '</a>' +
            '<price-list class="price-list">' +
              '<sale-price class="' + priceClass + '">' + formatPrice(product.price) + '</sale-price>' +
              compareHtml +
            '</price-list>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function formatPrice(price) {
    var num = parseFloat(price);
    return isNaN(num) ? '' : '\u00a3' + num.toFixed(2);
  }

  function getOrCreateSessionId() {
    var id = localStorage.getItem('ikrush_session_id');
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem('ikrush_session_id', id);
    }
    return id;
  }

  function populateGrid(el, products) {
    var grid = el.querySelector('.recommendation-grid');
    if (!grid) return;
    grid.innerHTML = products.map(renderProductCard).join('');
  }

  // Similar products
  document.querySelectorAll('[data-similar-products]').forEach(function(el) {
    var productId = el.dataset.productId;
    var limit = el.dataset.limit || 8;
    fetchRecommendations('/api/recommendations/similar', {
      product_id: productId, limit: limit
    }).then(function(data) {
      if (!data || !data.products || data.products.length === 0) {
        el.remove();
        return;
      }
      populateGrid(el, data.products);
    });
  });

  // Personalised picks
  document.querySelectorAll('[data-personalised-picks]').forEach(function(el) {
    var sessionId = getOrCreateSessionId();
    var limit = el.dataset.limit || 12;
    fetchRecommendations('/api/recommendations/personalised', {
      session_id: sessionId, limit: limit
    }).then(function(data) {
      if (!data || !data.products || data.products.length === 0) {
        el.remove();
        return;
      }
      populateGrid(el, data.products);
    });
  });

  window.__ikrush_recs = { getOrCreateSessionId: getOrCreateSessionId };
})();
